module.exports = __webpack_public_path__ + "static/delivering-happiness-a34af77e1d2fd7d2fed3497afc6e7388.jpg";